import { render, staticRenderFns } from "./NetCourse.vue?vue&type=template&id=063012b1&scoped=true&"
import script from "./NetCourse.vue?vue&type=script&lang=js&"
export * from "./NetCourse.vue?vue&type=script&lang=js&"
import style0 from "./NetCourse.vue?vue&type=style&index=0&id=063012b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063012b1",
  null
  
)

export default component.exports